document.addEventListener('DOMContentLoaded', function() {
  const bottomBar = document.getElementById('bottom-bar');
  const bottomBarCloseButton = document.getElementById('bottom-bar-close');

  bottomBarCloseButton.addEventListener('click', function() {
    bottomBar.style.bottom = '-400px'; // Hide the bottom bar
    setTimeout(() => {
      if (bottomBar && bottomBar.parentNode) {
        bottomBar.parentNode.removeChild(bottomBar);
      }
    }, 400);
  });

  window.addEventListener('scroll', function() {
    const scrollPosition = window.scrollY || window.pageYOffset;
    const pageHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercentage = (scrollPosition / pageHeight) * 100;

    if (window.location.pathname === '/pages/plans') {
      if (scrollPercentage > 15) {
        bottomBar.style.bottom = '0'; // Show the bottom bar
      } else {
        bottomBar.style.bottom = '-400px'; // Hide the bottom bar
      }
    } else {
      if (scrollPercentage > 40) {
        bottomBar.style.bottom = '0'; // Show the bottom bar
      } else {
        bottomBar.style.bottom = '-400px'; // Hide the bottom bar
      }
    }
  });

  if (window.location.pathname === '/pages/plans') {
    const handleResize = () => {
      if (window.innerWidth < 950) {
        const residentialPlanElement = document.getElementById('bottom-bar-content-mobile-residential');
        const travelPlanElement = document.getElementById('bottom-bar-content-mobile-travel');
        const defaultMobileView = document.getElementById('bottom-bar-content-mobile-default');

        if (window.bottomBarPlan === 'travel') {
          travelPlanElement.style.display = 'flex';
          residentialPlanElement.style.display = 'none';
        } else if (window.bottomBarPlan === 'residential') {
          travelPlanElement.style.display = 'none';
          residentialPlanElement.style.display = 'flex';
        } else {
          travelPlanElement.style.display = 'none';
          residentialPlanElement.style.display = 'none';
          defaultMobileView.style.display = 'flex';
        }
      } else {
        const residentialPlanElement = document.getElementById('bottom-bar-content-mobile-residential');
        const travelPlanElement = document.getElementById('bottom-bar-content-mobile-travel');
        const defaultMobileView = document.getElementById('bottom-bar-content-mobile-default');

        residentialPlanElement.style.display = 'none';
        travelPlanElement.style.display = 'none';
        defaultMobileView.style.display = 'none';
      }
    };

    // Call the function initially
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    const checkoutButton = document.getElementById('bottom-bar-checkout-button');
    const checkoutButtonMobileResidential = document.getElementById('bottom-bar-checkout-button-mobile-residential');
    const checkoutButtonMobileTravel = document.getElementById('bottom-bar-checkout-button-mobile-travel');
    const plansPageCheckoutButton = document.getElementById('checkout-button');
    const plansPageCheckoutButtonB = document.getElementById('checkout-button-b');

    if (window.plansPageVersion === 'A') {
      checkoutButton.addEventListener('click', function() {
        plansPageCheckoutButton.click();
      });

      checkoutButtonMobileResidential.addEventListener('click', function() {
        plansPageCheckoutButton.click();
      });

      checkoutButtonMobileTravel.addEventListener('click', function() {
        plansPageCheckoutButton.click();
      });
    } else if (window.plansPageVersion === 'B') {
      checkoutButton.addEventListener('click', function() {
        plansPageCheckoutButtonB.click();
      });

      checkoutButtonMobileResidential.addEventListener('click', function() {
        plansPageCheckoutButtonB.click();
      });

      checkoutButtonMobileTravel.addEventListener('click', function() {
        plansPageCheckoutButtonB.click();
      });
    }
  }
});

const updateBottomBarPlan = (planName) => {
  window.bottomBarPlan = planName;

  const planPriceElement = document.getElementById('bottom-bar-plan-price');
  const residentialPlanImageElement = document.getElementById('bottom-bar-residential-image');
  const travelPlanImageElement = document.getElementById('bottom-bar-travel-image');
  const residentialPlanLogoElement = document.getElementById('bottom-bar-residential-logo');
  const travelPlanLogoElement = document.getElementById('bottom-bar-travel-logo');

  if (window.innerWidth < 950) {
    const residentialPlanElement = document.getElementById('bottom-bar-content-mobile-residential');
    const travelPlanElement = document.getElementById('bottom-bar-content-mobile-travel');
    const defaultMobileView = document.getElementById('bottom-bar-content-mobile-default');

    defaultMobileView.style.display = 'none';
    if (planName === 'travel') {
      travelPlanElement.style.display = 'flex';
      residentialPlanElement.style.display = 'none';
    } else {
      travelPlanElement.style.display = 'none';
      residentialPlanElement.style.display = 'flex';
    }
  }

  if (planName === 'travel') {
    planPriceElement.textContent = '$129.95';
    travelPlanImageElement.style.display = 'block';
    travelPlanLogoElement.style.display = 'block';
    residentialPlanImageElement.style.display = 'none';
    residentialPlanLogoElement.style.display = 'none';
  } else {
    planPriceElement.textContent = '$99.95';
    residentialPlanImageElement.style.display = 'block';
    residentialPlanLogoElement.style.display = 'block';
    travelPlanImageElement.style.display = 'none';
    travelPlanLogoElement.style.display = 'none';
  }

  if (window.location.pathname === '/pages/plans') {
    const checkCoverageButton = document.getElementById('bottom-bar-coverage-checker-trigger');
    const checkoutButton = document.getElementById('bottom-bar-checkout-button');

    checkCoverageButton.style.display = 'none';
    checkoutButton.style.display = 'block';
  }
};
